<template>
  <div>
    <EditListModal v-if="editList" />
    <NewListModal v-else-if="newList" />
    <ImportListModal v-else-if="importList" />
    <SaveListModal v-else-if="saveList" />
    <SendReport v-else-if="sendReport" />
    <AnalyticsModal />
  </div>
</template>

<script>
import EditListModal from "./EditListModal.vue";
import NewListModal from "./NewListModal.vue";
import SaveListModal from "./SaveListModal.vue";
import ImportListModal from "./import/ImportListModal.vue";

import { sync } from "vuex-pathify";

export default {
  computed: {
    editList: sync("ui/modal@list.edit.open"),
    newList: sync("ui/modal@list.new.open"),
    saveList: sync("ui/modal@list.save.open"),
    importList: sync("ui/modal@list.import.open"),
    sendReport: sync("ui/modal@email.report.open"),
    analytics: sync("ui/modal@analytics"),
  },
  components: {
    EditListModal,
    NewListModal,
    ImportListModal,
    SaveListModal,
    AnalyticsModal: () => import("./AnalyticsModal.vue"),
    SendReport: () => import("./email/SendReport.vue"),
  },
};
</script>